import type { SnackBarState } from '..';
import type { DisplayStrategyCallback } from '.';

export function create(state: SnackBarState): DisplayStrategyCallback {
  return () => {
    return Promise.resolve(!state.closed);
  };
}
